
import { Vue, Options, Prop } from 'vue-property-decorator';

import Nomination from '@/service/nomination';

import MaterialIconButton from '@/components/material/IconButton.vue';

import locales from './Actions.locales.json';

@Options({
    components: {
        MaterialIconButton,
    },
    i18n: {
        messages: locales
    }
})
export default class ActionsBlock extends Vue {

    @Prop(Nomination) readonly nomination!: Nomination;

    openIntel() {
        window.open(this.nomination.intelUrl, '_blank');
    }

    openBs() {
        window.open(this.nomination.bsUrl, '_blank');
    }
}
